import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _bcd5ec8a = () => interopDefault(import('../pages/bedrijven/index.vue' /* webpackChunkName: "pages/bedrijven/index" */))
const _4e524256 = () => interopDefault(import('../pages/construction.vue' /* webpackChunkName: "pages/construction" */))
const _8a25a6d8 = () => interopDefault(import('../pages/instellingen/index.vue' /* webpackChunkName: "pages/instellingen/index" */))
const _5494f637 = () => interopDefault(import('../pages/login/index.vue' /* webpackChunkName: "pages/login/index" */))
const _270eb14e = () => interopDefault(import('../pages/opdrachten/index.vue' /* webpackChunkName: "pages/opdrachten/index" */))
const _6801cc5a = () => interopDefault(import('../pages/overzicht/index.vue' /* webpackChunkName: "pages/overzicht/index" */))
const _688c2621 = () => interopDefault(import('../pages/personeelsplanning/index.vue' /* webpackChunkName: "pages/personeelsplanning/index" */))
const _6c36735a = () => interopDefault(import('../pages/relaties/index.vue' /* webpackChunkName: "pages/relaties/index" */))
const _17814ada = () => interopDefault(import('../pages/urenregistratie/index.vue' /* webpackChunkName: "pages/urenregistratie/index" */))
const _0537f0c2 = () => interopDefault(import('../pages/werknemers/index.vue' /* webpackChunkName: "pages/werknemers/index" */))
const _8fae46ca = () => interopDefault(import('../pages/account/customer-register.vue' /* webpackChunkName: "pages/account/customer-register" */))
const _8cf6450a = () => interopDefault(import('../pages/account/registreren.vue' /* webpackChunkName: "pages/account/registreren" */))
const _08d195c8 = () => interopDefault(import('../pages/bedrijven/aanmaken/index.vue' /* webpackChunkName: "pages/bedrijven/aanmaken/index" */))
const _310d3996 = () => interopDefault(import('../pages/bedrijven/bekijken/index.vue' /* webpackChunkName: "pages/bedrijven/bekijken/index" */))
const _d91544da = () => interopDefault(import('../pages/bedrijven/subscriptie/index.vue' /* webpackChunkName: "pages/bedrijven/subscriptie/index" */))
const _8e62b220 = () => interopDefault(import('../pages/instellingen/labels/index.vue' /* webpackChunkName: "pages/instellingen/labels/index" */))
const _399f7c14 = () => interopDefault(import('../pages/instellingen/ort/index.vue' /* webpackChunkName: "pages/instellingen/ort/index" */))
const _0b4f8a0e = () => interopDefault(import('../pages/instellingen/subscription/index.vue' /* webpackChunkName: "pages/instellingen/subscription/index" */))
const _cecab124 = () => interopDefault(import('../pages/login/index copy.vue' /* webpackChunkName: "pages/login/index copy" */))
const _599fab30 = () => interopDefault(import('../pages/login/profielen/index.vue' /* webpackChunkName: "pages/login/profielen/index" */))
const _7ff84ba9 = () => interopDefault(import('../pages/login/uitnodiging/index.vue' /* webpackChunkName: "pages/login/uitnodiging/index" */))
const _ef489b9e = () => interopDefault(import('../pages/login/verifieer/index.vue' /* webpackChunkName: "pages/login/verifieer/index" */))
const _156996b2 = () => interopDefault(import('../pages/login/wachtwoord/index.vue' /* webpackChunkName: "pages/login/wachtwoord/index" */))
const _85953a2e = () => interopDefault(import('../pages/opdrachten/aanmaken/index.vue' /* webpackChunkName: "pages/opdrachten/aanmaken/index" */))
const _add0ddfc = () => interopDefault(import('../pages/opdrachten/bekijken/index.vue' /* webpackChunkName: "pages/opdrachten/bekijken/index" */))
const _044700f6 = () => interopDefault(import('../pages/personeelsplanning/index-with-store.vue' /* webpackChunkName: "pages/personeelsplanning/index-with-store" */))
const _29e75202 = () => interopDefault(import('../pages/profielen/bekijken/index.vue' /* webpackChunkName: "pages/profielen/bekijken/index" */))
const _54f2c170 = () => interopDefault(import('../pages/profielen/overzicht.vue' /* webpackChunkName: "pages/profielen/overzicht" */))
const _9253b8f8 = () => interopDefault(import('../pages/relaties/aanmaken/index.vue' /* webpackChunkName: "pages/relaties/aanmaken/index" */))
const _4cf56dca = () => interopDefault(import('../pages/relaties/onderaannemer-aanmaken/index.vue' /* webpackChunkName: "pages/relaties/onderaannemer-aanmaken/index" */))
const _1c9ac7fc = () => interopDefault(import('../pages/uren/bekijken/index.vue' /* webpackChunkName: "pages/uren/bekijken/index" */))
const _2dbd97b8 = () => interopDefault(import('../pages/werknemers/aanmaken/index.vue' /* webpackChunkName: "pages/werknemers/aanmaken/index" */))
const _b38a28b2 = () => interopDefault(import('../pages/instellingen/ort/regels/index.vue' /* webpackChunkName: "pages/instellingen/ort/regels/index" */))
const _816a6db4 = () => interopDefault(import('../pages/instellingen/planner/volgorde/index.vue' /* webpackChunkName: "pages/instellingen/planner/volgorde/index" */))
const _b4070e9c = () => interopDefault(import('../pages/instellingen/rapport/export/index.vue' /* webpackChunkName: "pages/instellingen/rapport/export/index" */))
const _c0c23e66 = () => interopDefault(import('../pages/instellingen/rollen/rechten/index.vue' /* webpackChunkName: "pages/instellingen/rollen/rechten/index" */))
const _89d13808 = () => interopDefault(import('../pages/login/wachtwoord/aanvragen/index.vue' /* webpackChunkName: "pages/login/wachtwoord/aanvragen/index" */))
const _134ba39d = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _3eddb54b = () => interopDefault(import('../pages/relaties/onderaannemer/_subcontractorId/index.vue' /* webpackChunkName: "pages/relaties/onderaannemer/_subcontractorId/index" */))
const _eede6b8e = () => interopDefault(import('../pages/werknemers/bekijken/_profileId/index.vue' /* webpackChunkName: "pages/werknemers/bekijken/_profileId/index" */))
const _6d67c40d = () => interopDefault(import('../pages/relaties/onderaannemer/_subcontractorId/bewerken/index.vue' /* webpackChunkName: "pages/relaties/onderaannemer/_subcontractorId/bewerken/index" */))
const _6bbdb1dc = () => interopDefault(import('../pages/relaties/onderaannemer/_subcontractorId/diensten/index.vue' /* webpackChunkName: "pages/relaties/onderaannemer/_subcontractorId/diensten/index" */))
const _494bbd31 = () => interopDefault(import('../pages/relaties/onderaannemer/_subcontractorId/werknemers/index.vue' /* webpackChunkName: "pages/relaties/onderaannemer/_subcontractorId/werknemers/index" */))
const _1f2a752d = () => interopDefault(import('../pages/werknemers/bekijken/_profileId/documenten.vue' /* webpackChunkName: "pages/werknemers/bekijken/_profileId/documenten" */))
const _5aa5d559 = () => interopDefault(import('../pages/werknemers/bekijken/_profileId/gegevens.vue' /* webpackChunkName: "pages/werknemers/bekijken/_profileId/gegevens" */))
const _07c6ebda = () => interopDefault(import('../pages/relaties/_relationId/index.vue' /* webpackChunkName: "pages/relaties/_relationId/index" */))
const _25ad3f5e = () => interopDefault(import('../pages/relaties/_relationId/contacten.vue' /* webpackChunkName: "pages/relaties/_relationId/contacten" */))
const _145d302c = () => interopDefault(import('../pages/relaties/_relationId/documenten.vue' /* webpackChunkName: "pages/relaties/_relationId/documenten" */))
const _16f94418 = () => interopDefault(import('../pages/relaties/_relationId/gegevens.vue' /* webpackChunkName: "pages/relaties/_relationId/gegevens" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/bedrijven",
    component: _bcd5ec8a,
    pathToRegexpOptions: {"strict":true},
    name: "bedrijven"
  }, {
    path: "/construction",
    component: _4e524256,
    pathToRegexpOptions: {"strict":true},
    name: "construction"
  }, {
    path: "/instellingen",
    component: _8a25a6d8,
    pathToRegexpOptions: {"strict":true},
    name: "instellingen"
  }, {
    path: "/login",
    component: _5494f637,
    pathToRegexpOptions: {"strict":true},
    name: "login"
  }, {
    path: "/opdrachten",
    component: _270eb14e,
    pathToRegexpOptions: {"strict":true},
    name: "opdrachten"
  }, {
    path: "/overzicht",
    component: _6801cc5a,
    pathToRegexpOptions: {"strict":true},
    name: "overzicht"
  }, {
    path: "/personeelsplanning",
    component: _688c2621,
    pathToRegexpOptions: {"strict":true},
    name: "personeelsplanning"
  }, {
    path: "/relaties",
    component: _6c36735a,
    pathToRegexpOptions: {"strict":true},
    name: "relaties"
  }, {
    path: "/urenregistratie",
    component: _17814ada,
    pathToRegexpOptions: {"strict":true},
    name: "urenregistratie"
  }, {
    path: "/werknemers",
    component: _0537f0c2,
    pathToRegexpOptions: {"strict":true},
    name: "werknemers"
  }, {
    path: "/account/customer-register",
    component: _8fae46ca,
    pathToRegexpOptions: {"strict":true},
    name: "account-customer-register"
  }, {
    path: "/account/registreren",
    component: _8cf6450a,
    pathToRegexpOptions: {"strict":true},
    name: "account-registreren"
  }, {
    path: "/bedrijven/aanmaken",
    component: _08d195c8,
    pathToRegexpOptions: {"strict":true},
    name: "bedrijven-aanmaken"
  }, {
    path: "/bedrijven/bekijken",
    component: _310d3996,
    pathToRegexpOptions: {"strict":true},
    name: "bedrijven-bekijken"
  }, {
    path: "/bedrijven/subscriptie",
    component: _d91544da,
    pathToRegexpOptions: {"strict":true},
    name: "bedrijven-subscriptie"
  }, {
    path: "/instellingen/labels",
    component: _8e62b220,
    pathToRegexpOptions: {"strict":true},
    name: "instellingen-labels"
  }, {
    path: "/instellingen/ort",
    component: _399f7c14,
    pathToRegexpOptions: {"strict":true},
    name: "instellingen-ort"
  }, {
    path: "/instellingen/subscription",
    component: _0b4f8a0e,
    pathToRegexpOptions: {"strict":true},
    name: "instellingen-subscription"
  }, {
    path: "/login/index%20copy",
    component: _cecab124,
    pathToRegexpOptions: {"strict":true},
    name: "login-index copy"
  }, {
    path: "/login/profielen",
    component: _599fab30,
    pathToRegexpOptions: {"strict":true},
    name: "login-profielen"
  }, {
    path: "/login/uitnodiging",
    component: _7ff84ba9,
    pathToRegexpOptions: {"strict":true},
    name: "login-uitnodiging"
  }, {
    path: "/login/verifieer",
    component: _ef489b9e,
    pathToRegexpOptions: {"strict":true},
    name: "login-verifieer"
  }, {
    path: "/login/wachtwoord",
    component: _156996b2,
    pathToRegexpOptions: {"strict":true},
    name: "login-wachtwoord"
  }, {
    path: "/opdrachten/aanmaken",
    component: _85953a2e,
    pathToRegexpOptions: {"strict":true},
    name: "opdrachten-aanmaken"
  }, {
    path: "/opdrachten/bekijken",
    component: _add0ddfc,
    pathToRegexpOptions: {"strict":true},
    name: "opdrachten-bekijken"
  }, {
    path: "/personeelsplanning/index-with-store",
    component: _044700f6,
    pathToRegexpOptions: {"strict":true},
    name: "personeelsplanning-index-with-store"
  }, {
    path: "/profielen/bekijken",
    component: _29e75202,
    pathToRegexpOptions: {"strict":true},
    name: "profielen-bekijken"
  }, {
    path: "/profielen/overzicht",
    component: _54f2c170,
    pathToRegexpOptions: {"strict":true},
    name: "profielen-overzicht"
  }, {
    path: "/relaties/aanmaken",
    component: _9253b8f8,
    pathToRegexpOptions: {"strict":true},
    name: "relaties-aanmaken"
  }, {
    path: "/relaties/onderaannemer-aanmaken",
    component: _4cf56dca,
    pathToRegexpOptions: {"strict":true},
    name: "relaties-onderaannemer-aanmaken"
  }, {
    path: "/uren/bekijken",
    component: _1c9ac7fc,
    pathToRegexpOptions: {"strict":true},
    name: "uren-bekijken"
  }, {
    path: "/werknemers/aanmaken",
    component: _2dbd97b8,
    pathToRegexpOptions: {"strict":true},
    name: "werknemers-aanmaken"
  }, {
    path: "/instellingen/ort/regels",
    component: _b38a28b2,
    pathToRegexpOptions: {"strict":true},
    name: "instellingen-ort-regels"
  }, {
    path: "/instellingen/planner/volgorde",
    component: _816a6db4,
    pathToRegexpOptions: {"strict":true},
    name: "instellingen-planner-volgorde"
  }, {
    path: "/instellingen/rapport/export",
    component: _b4070e9c,
    pathToRegexpOptions: {"strict":true},
    name: "instellingen-rapport-export"
  }, {
    path: "/instellingen/rollen/rechten",
    component: _c0c23e66,
    pathToRegexpOptions: {"strict":true},
    name: "instellingen-rollen-rechten"
  }, {
    path: "/login/wachtwoord/aanvragen",
    component: _89d13808,
    pathToRegexpOptions: {"strict":true},
    name: "login-wachtwoord-aanvragen"
  }, {
    path: "/",
    component: _134ba39d,
    pathToRegexpOptions: {"strict":true},
    name: "index"
  }, {
    path: "/relaties/onderaannemer/:subcontractorId",
    component: _3eddb54b,
    pathToRegexpOptions: {"strict":true},
    name: "relaties-onderaannemer-subcontractorId"
  }, {
    path: "/werknemers/bekijken/:profileId",
    component: _eede6b8e,
    pathToRegexpOptions: {"strict":true},
    name: "werknemers-bekijken-profileId"
  }, {
    path: "/relaties/onderaannemer/:subcontractorId?/bewerken",
    component: _6d67c40d,
    pathToRegexpOptions: {"strict":true},
    name: "relaties-onderaannemer-subcontractorId-bewerken"
  }, {
    path: "/relaties/onderaannemer/:subcontractorId?/diensten",
    component: _6bbdb1dc,
    pathToRegexpOptions: {"strict":true},
    name: "relaties-onderaannemer-subcontractorId-diensten"
  }, {
    path: "/relaties/onderaannemer/:subcontractorId?/werknemers",
    component: _494bbd31,
    pathToRegexpOptions: {"strict":true},
    name: "relaties-onderaannemer-subcontractorId-werknemers"
  }, {
    path: "/werknemers/bekijken/:profileId?/documenten",
    component: _1f2a752d,
    pathToRegexpOptions: {"strict":true},
    name: "werknemers-bekijken-profileId-documenten"
  }, {
    path: "/werknemers/bekijken/:profileId?/gegevens",
    component: _5aa5d559,
    pathToRegexpOptions: {"strict":true},
    name: "werknemers-bekijken-profileId-gegevens"
  }, {
    path: "/relaties/:relationId",
    component: _07c6ebda,
    pathToRegexpOptions: {"strict":true},
    name: "relaties-relationId"
  }, {
    path: "/relaties/:relationId/contacten",
    component: _25ad3f5e,
    pathToRegexpOptions: {"strict":true},
    name: "relaties-relationId-contacten"
  }, {
    path: "/relaties/:relationId/documenten",
    component: _145d302c,
    pathToRegexpOptions: {"strict":true},
    name: "relaties-relationId-documenten"
  }, {
    path: "/relaties/:relationId/gegevens",
    component: _16f94418,
    pathToRegexpOptions: {"strict":true},
    name: "relaties-relationId-gegevens"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
